module.exports = __webpack_public_path__ + "_app/img/per-empty.eec85cef.png";